import React, { useEffect, useState } from "react";
import Card, { CardBody, CardHeader } from "../components/ui/Card/Card";
import Button from "../components/ui/Button/Button";
import AdminPanel from "../components/sections/Admin/AdminPanel";
import { onAuth, signIn, signOutUser } from "../services/firebase";

const Admin: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const [email, setEmail] = useState("esfotomotivadmin@esf-otomotiv.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const unsub = onAuth(setUser);
    return () => unsub();
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (err: any) {
      setError(err?.message || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try { await signOutUser(); } catch {}
  };

  if (!user) {
    return (
      <section className="admin">
        <div className="container">
          <Card variant="elevated" className="admin__card">
            <CardHeader>
              <h2>Admin Girişi</h2>
              <p>Yalnızca yetkili kullanıcılar</p>
            </CardHeader>
            <CardBody>
              <form className="admin__form" onSubmit={handleLogin}>
                <div className="admin__form-row">
                  <label>E-posta</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="admin__form-row">
                  <label>Şifre</label>
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <div className="admin__form-actions">
                  <Button>{loading ? "Giriş Yapılıyor..." : "Giriş Yap"}</Button>
                </div>
                {error && <p className="admin__error">{error}</p>}
              </form>
            </CardBody>
          </Card>
        </div>
      </section>
    );
  }

  return (
    <>
      <AdminPanel />
      <div className="container" style={{ marginTop: 12 }}>
        <button className="button button--outline" onClick={handleLogout}>Çıkış Yap</button>
      </div>
    </>
  );
};

export default Admin;